import React from 'react';
import {
    Alert,
    Box,
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    TextField,
    Typography,
} from "@mui/material";
import {
    CloseRounded,
    PaymentRounded,
} from "@mui/icons-material";
import { toPriceWithComma } from "../../../helper/utils";

const _InvoicePayModal = ({
    itemToPay,
    onClose,
    submitting,
    handleCompletePay,
    getlabelOfRefrence,
    transactionReference,
    setTransactionReference,
}) => {
    return (
        <Dialog
            open={!!itemToPay}
            onClose={() => !submitting && onClose()}
            maxWidth="xs"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 4,
                    p: 1,
                    boxShadow: '0 20px 45px rgba(0,0,0,0.12)'
                }
            }}
        >
            <Box component="form" onSubmit={handleCompletePay}>
                <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pb: 1 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.2 }}>
                        <Box
                            sx={{
                                width: 38,
                                height: 38,
                                borderRadius: 2.5,
                                bgcolor: 'rgba(28, 139, 156, 0.1)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: 'primary.main'
                            }}
                        >
                            <PaymentRounded fontSize="small" />
                        </Box>
                        <Typography variant="h6" sx={{ fontWeight: 800, fontSize: '1.05rem' }}>
                            تکمیل و ثبت پرداخت
                        </Typography>
                    </Box>
                    <IconButton
                        size="small"
                        onClick={onClose}
                        disabled={submitting}
                        sx={{ color: 'text.secondary' }}
                    >
                        <CloseRounded fontSize="small" />
                    </IconButton>
                </DialogTitle>

                <DialogContent sx={{ pt: 1.5 }}>
                    <Alert severity="info" sx={{ mb: 2, borderRadius: 2.5, fontSize: '0.8rem' }}>
                        مبالغ پرداخت‌شده توسط واحد مالی جیم‌پین بررسی و پس از تایید (حداکثر ۲۴ ساعت)، شارژ اعمال می‌گردد.
                    </Alert>

                    <Box sx={{ p: 1.8, borderRadius: 2.5, bgcolor: 'background.default', border: '1px solid', borderColor: 'divider', mb: 2 }}>
                        <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block' }}>مبلغ پیش‌فاکتور:</Typography>
                        <Typography variant="h6" sx={{ fontWeight: 900, color: 'primary.main' }}>
                            {toPriceWithComma(itemToPay?.Amount)} تومان
                        </Typography>
                    </Box>

                    <TextField
                        autoFocus
                        label={getlabelOfRefrence()}
                        placeholder="کد پیگیری یا شماره فیش پرداخت..."
                        value={transactionReference}
                        onChange={(e) => setTransactionReference(e.target.value)}
                        fullWidth
                        required
                        sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2.5 } }}
                    />
                </DialogContent>

                <DialogActions sx={{ px: 3, pb: 2, pt: 1, gap: 1 }}>
                    <Button
                        variant="text"
                        onClick={onClose}
                        disabled={submitting}
                        sx={{ borderRadius: 2.5, px: 2, color: 'text.secondary' }}
                    >
                        انصراف
                    </Button>
                    <Button
                        type="submit"
                        variant="contained"
                        disabled={submitting || !transactionReference}
                        sx={{
                            borderRadius: 2.5,
                            px: 3,
                            fontWeight: 700,
                            boxShadow: '0 4px 14px rgba(28, 139, 156, 0.25)'
                        }}
                    >
                        {submitting ? <CircularProgress size={20} color="inherit" /> : "ثبت پرداخت"}
                    </Button>
                </DialogActions>
            </Box>
        </Dialog>
    );
};

export default _InvoicePayModal;
